// extracted by mini-css-extract-plugin
export default {"greatDeal":"GreatDeal_greatDeal__Rmut6"};